<template>
  <div class="app-container">
    <order-log-filters :export-disabled="loading || !appliedParams || !!queryError || exporting" @query="query" @export="exportLogs" />
    <el-card v-loading="loading">
      <el-alert
        v-if="queryError" :title="queryError" type="error"
        :closable="false" show-icon class="query-error"
      />
      <order-log-table
        :rows="rows" :page-number="pageNumber" :page-size="pageSize"
        :empty-text="emptyText" @detail="showDetail"
      />
      <div class="pagination">
        <el-pagination
          :current-page="pageNumber" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
          :total="total" background layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePage" @size-change="changeSize"
        />
      </div>
    </el-card>
    <order-log-drawer :visible.sync="drawerVisible" :update-form="detail" />
  </div>
</template>
<script>
import { apiOrderLog, orderLogExportList } from '@/api/orderApi';
import { goResourceTaskList } from '@/utils/goExportList';
import { formatOrderLogRecords } from './orderLogQuery';
import OrderLogFilters from './OrderLogFilters.vue';
import OrderLogTable from './OrderLogTable.vue';
import OrderLogDrawer from './OrderLogDrawer.vue';
export default {
  name: 'OrderLogs',
  components: { OrderLogFilters, OrderLogTable, OrderLogDrawer },
  data() {
    return {
      pageNumber: 1, pageSize: 10, appliedParams: null, rows: [], total: 0,
      loading: false, exporting: false, queryError: '', requestSequence: 0,
      drawerVisible: false, detail: {}
    };
  },
  computed: {
    emptyText() { return this.queryError || this.$t('orderLogAddress.empty'); }
  },
  beforeDestroy() { this.requestSequence++; },
  methods: {
    query(params) { this.appliedParams = params; this.pageNumber = 1; return this.load(); },
    request() {
      return { pageNumber: this.pageNumber, pageSize: this.pageSize, params: { ...this.appliedParams }};
    },
    async load() {
      const sequence = ++this.requestSequence;
      this.loading = true; this.queryError = '';
      try {
        const result = await apiOrderLog(this.request());
        if (sequence !== this.requestSequence) return;
        if (result.code !== 200 || !result.data) throw new Error(result.msg || this.$t('orderLogAddress.queryFailed'));
        this.rows = formatOrderLogRecords(result.data.records);
        this.total = result.data.total;
      } catch (error) {
        if (sequence === this.requestSequence) {
          this.rows = []; this.total = 0;
          this.queryError = error.message || this.$t('orderLogAddress.queryFailed');
        }
      } finally {
        if (sequence === this.requestSequence) this.loading = false;
      }
    },
    changePage(page) { this.pageNumber = page; return this.load(); },
    changeSize(size) { this.pageSize = size; this.pageNumber = 1; return this.load(); },
    showDetail(row) { this.detail = row; this.drawerVisible = true; },
    async exportLogs() {
      if (!this.appliedParams || this.queryError || this.loading || this.exporting) return;
      this.exporting = true;
      try {
        // 导出复用已查询的筛选条件，翻页或编辑尚未提交的筛选不会改变导出范围。
        const result = await orderLogExportList(this.request());
        if (result.code !== 200) throw new Error(result.msg || this.$t('orderLogAddress.exportFailed'));
        goResourceTaskList();
      } catch (error) {
        this.$message.error(error.message || this.$t('orderLogAddress.exportFailed'));
      } finally { this.exporting = false; }
    }
  }
};
</script>
<style scoped>
.pagination { margin-top: 14px; overflow-x: auto; }
.query-error { margin-bottom: 14px; }
</style>
